import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class OmriyanaProductStatus extends Component {
  #listeners;

  connectedCallback() {
    super.connectedCallback();
    this.#listeners?.abort();
    this.#listeners = new AbortController();
    this.closest('.shopify-section, dialog')?.addEventListener(ThemeEvents.variantUpdate, this.updateStatus, {
      signal: this.#listeners.signal,
    });
  }

  disconnectedCallback() {
    this.#listeners?.abort();
    super.disconnectedCallback();
  }

  updateStatus = (event) => {
    const { data } = event.detail;
    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (String(data.productId) !== this.dataset.productId) {
      return;
    }
    const next = data.html.querySelector(
      `omriyana-product-status[data-block-id="${this.dataset.blockId}"][data-display="${this.dataset.display}"]`
    );
    if (!next) return;
    this.hidden = next.hidden;
    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('omriyana-product-status')) {
  customElements.define('omriyana-product-status', OmriyanaProductStatus);
}
